import React, { useState, useEffect } from 'react';
import { Button } from '../../../../../components/ui/Button/Button';
import { ResumoPendencias } from '../../../../../components/ui/ResumoPendencias/ResumoPendencias';
import { destacarPendencias } from '../../../../../utils/destaqueCampos';
import FormSectionComponent from './FormSectionComponent';
import CheckboxProgress from './CheckboxProgress';
import { ButtonsContainer } from './styles';
import { validateSection, isCampoVisivel } from '../../utils/validation';

const FormStep = ({
  step, formData, errors, touched, onChange, onBlur,
  onNext, onPrev, isFirst, isLast, loading, setErrors, setTouched,
  nextLabelOnLast = 'Próximo: Documentos →'
}) => {
  const [tentouAvancar, setTentouAvancar] = useState(false);

  useEffect(() => {
    setTentouAvancar(false);
  }, [step]);

  // Derivado de `errors` (e não guardado à parte): o handleChange já limpa o erro
  // do campo ao ser editado, então o resumo encolhe e some sozinho.
  const camposComErro = step.sections
    .flatMap(section => section.fields)
    .filter(field => isCampoVisivel(field, formData))
    .filter(field => errors[field.name]);

  const validateCurrentSection = () => {
    const sectionErrors = {};

    step.sections.forEach(section => {
      const errors = validateSection(section, formData);
      Object.assign(sectionErrors, errors);
    });

    if (Object.keys(sectionErrors).length > 0) {
      setErrors(sectionErrors);
      return sectionErrors;
    }

    return null;
  };

  const handleNext = () => {
    const sectionErrors = validateCurrentSection();

    if (!sectionErrors) {
      setTentouAvancar(false);
      onNext();
      return;
    }

    const nomesComErro = step.sections
      .flatMap(section => section.fields)
      .map(field => field.name)
      .filter(name => sectionErrors[name]);

    // Sem "touched" os campos não exibem o erro (error={touched && error}),
    // e quem nunca clicou no campo não veria o que falta.
    setTouched?.(prev => ({
      ...prev,
      ...Object.fromEntries(nomesComErro.map(name => [name, true]))
    }));
    setTentouAvancar(true);
    destacarPendencias(nomesComErro);
  };

  return (
    <>
      {step.sections.map((section, idx) => (
        <FormSectionComponent
          key={idx}
          section={section}
          formData={formData}
          errors={errors}
          touched={touched}
          onChange={onChange}
          onBlur={onBlur}
          setErrors={setErrors}
        />
      ))}

      <CheckboxProgress step={step} formData={formData} />

      {tentouAvancar && (
        <ResumoPendencias
          itens={camposComErro.map(field => ({
            id: field.name,
            label: field.label || field.name,
            detalhe: errors[field.name]
          }))}
          onClose={() => setTentouAvancar(false)}
        />
      )}

      <ButtonsContainer>
        {!isFirst && (
          <Button variant="secondary" onClick={onPrev} disabled={loading}>
            ← Voltar
          </Button>
        )}
        <Button variant="primary" onClick={handleNext} disabled={loading}>
          {isLast ? nextLabelOnLast : 'Próximo →'}
        </Button>
      </ButtonsContainer>
    </>
  );
};

export default FormStep;
